/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyDetailsDto } from '../models/CompanyDetailsDto';
import type { CompanyDetailsFinancialsDto } from '../models/CompanyDetailsFinancialsDto';
import type { CompanyDetailsFundingEntryDto } from '../models/CompanyDetailsFundingEntryDto';
import type { CompanyEmployeesDto } from '../models/CompanyEmployeesDto';
import type { CompanyFieldDetailsDto } from '../models/CompanyFieldDetailsDto';
import type { CompanyLocationsDto } from '../models/CompanyLocationsDto';
import type { CompanyLocationsQueryDto } from '../models/CompanyLocationsQueryDto';
import type { CompanyNewsDto } from '../models/CompanyNewsDto';
import type { CompanyOfficeLocationFiltersDto } from '../models/CompanyOfficeLocationFiltersDto';
import type { CompanyOwnershipsDto } from '../models/CompanyOwnershipsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CompanyDetailsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns CompanyDetailsDto
     * @throws ApiError
     */
    public get({
        id,
    }: {
        id: string,
    }): CancelablePromise<CompanyDetailsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/companies/{id}/details',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns CompanyEmployeesDto
     * @throws ApiError
     */
    public getEmployees({
        id,
        itemsPerPage,
        page,
        query,
        since,
    }: {
        id: string,
        itemsPerPage: number,
        page: number,
        query?: string,
        since?: string,
    }): CancelablePromise<CompanyEmployeesDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/companies/{id}/details/employees',
            path: {
                'id': id,
            },
            query: {
                'query': query,
                'since': since,
                'items_per_page': itemsPerPage,
                'page': page,
            },
        });
    }
    /**
     * @returns CompanyLocationsDto
     * @throws ApiError
     */
    public getLocations({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: CompanyLocationsQueryDto,
    }): CancelablePromise<CompanyLocationsDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/companies/{id}/details/offices',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns CompanyFieldDetailsDto
     * @throws ApiError
     */
    public getWebsites({
        id,
        itemsPerPage,
        page,
        query,
    }: {
        id: string,
        itemsPerPage: number,
        page: number,
        query?: string,
    }): CancelablePromise<CompanyFieldDetailsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/companies/{id}/details/websites',
            path: {
                'id': id,
            },
            query: {
                'query': query,
                'items_per_page': itemsPerPage,
                'page': page,
            },
        });
    }
    /**
     * @returns CompanyFieldDetailsDto
     * @throws ApiError
     */
    public getPhones({
        id,
        itemsPerPage,
        page,
        query,
    }: {
        id: string,
        itemsPerPage: number,
        page: number,
        query?: string,
    }): CancelablePromise<CompanyFieldDetailsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/companies/{id}/details/phones',
            path: {
                'id': id,
            },
            query: {
                'query': query,
                'items_per_page': itemsPerPage,
                'page': page,
            },
        });
    }
    /**
     * @returns CompanyFieldDetailsDto
     * @throws ApiError
     */
    public getEmails({
        id,
        itemsPerPage,
        page,
        query,
    }: {
        id: string,
        itemsPerPage: number,
        page: number,
        query?: string,
    }): CancelablePromise<CompanyFieldDetailsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/companies/{id}/details/emails',
            path: {
                'id': id,
            },
            query: {
                'query': query,
                'items_per_page': itemsPerPage,
                'page': page,
            },
        });
    }
    /**
     * @returns CompanyFieldDetailsDto
     * @throws ApiError
     */
    public getSocialLinks({
        id,
        platform,
        itemsPerPage,
        page,
        query,
    }: {
        id: string,
        platform: string,
        itemsPerPage: number,
        page: number,
        query?: string,
    }): CancelablePromise<CompanyFieldDetailsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/companies/{id}/details/social-links',
            path: {
                'id': id,
            },
            query: {
                'query': query,
                'platform': platform,
                'items_per_page': itemsPerPage,
                'page': page,
            },
        });
    }
    /**
     * @returns CompanyOwnershipsDto
     * @throws ApiError
     */
    public getOwnerships({
        id,
    }: {
        id: string,
    }): CancelablePromise<CompanyOwnershipsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/companies/{id}/details/ownerships',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns CompanyOfficeLocationFiltersDto
     * @throws ApiError
     */
    public getOfficeLocationFilters({
        id,
        itemsPerPage,
        page,
        query,
    }: {
        id: string,
        itemsPerPage: number,
        page: number,
        query?: string,
    }): CancelablePromise<CompanyOfficeLocationFiltersDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/companies/{id}/details/office-location-filters',
            path: {
                'id': id,
            },
            query: {
                'query': query,
                'items_per_page': itemsPerPage,
                'page': page,
            },
        });
    }
    /**
     * @returns CompanyNewsDto
     * @throws ApiError
     */
    public getNews({
        id,
        itemsPerPage,
        page,
        query,
    }: {
        id: string,
        itemsPerPage: number,
        page: number,
        query?: string,
    }): CancelablePromise<CompanyNewsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/companies/{id}/details/news',
            path: {
                'id': id,
            },
            query: {
                'query': query,
                'items_per_page': itemsPerPage,
                'page': page,
            },
        });
    }
    /**
     * @returns CompanyDetailsFundingEntryDto
     * @throws ApiError
     */
    public getFunding({
        id,
        query,
    }: {
        id: string,
        query?: string,
    }): CancelablePromise<Array<CompanyDetailsFundingEntryDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/companies/{id}/details/funding',
            path: {
                'id': id,
            },
            query: {
                'query': query,
            },
        });
    }
    /**
     * @returns CompanyDetailsFinancialsDto
     * @throws ApiError
     */
    public getFinancials({
        id,
    }: {
        id: string,
    }): CancelablePromise<CompanyDetailsFinancialsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/companies/{id}/details/financials',
            path: {
                'id': id,
            },
        });
    }
}
